import { css } from '@emotion/css'

const styles = {
  wrapper: css({
    flexDirection: 'column',
  }),

  countrylist: css({
    marginBottom: 42,
    span: {
      width: 554,
    },
  }),
  helpText: css({
    marginBottom: 21,
    span: {
      width: 537,
    },
  }),
  link: css({
    width: '100%',
    marginBottom: 24,
  }),
}

export default styles
